import { AccountData } from '@types';
import { ChurnNoticeButton } from '@/components/AccountDetails/ChurnNoticeButton';

export function ChurnRiskDetail({
  statusData,
  clientData,
}: {
  statusData: string;
  clientData: AccountData;
}) {
  return (
    <div className='w-full'>
      <ChurnNoticeButton clientData={clientData} />
      <div className='w-1/2 flex items-center text-lg font-bold'>
        Status Updates
      </div>
      {statusData.split('\n').map((line, index) => {
        const [firstWord, ...rest] = line.split(' ');
        const restOfLine = rest.join(' ');

        let color = '';
        if (firstWord.toLowerCase() === 'yellow') {
          color = 'var(--special-yellow)';
        } else if (firstWord.toLowerCase() === 'red') {
          color = 'red';
        } else if (firstWord.toLowerCase() === 'green') {
          color = 'green';
        }

        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`status_${index}`} className='my-3'>
            {color ? (
              <>
                <span style={{ color, fontWeight: 'bold' }}>{firstWord}</span>{' '}
                {restOfLine}
              </>
            ) : (
              line
            )}
          </div>
        );
      })}
    </div>
  );
}
